@use '@/styles/tokens' as *;

// The chart scrolls horizontally only when its labels would otherwise overflow; the Y axis stays
// put because recharts renders it inside the same responsive container.
.chart {
  overflow-x: auto;
  min-width: 0;
}

.tooltip {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 10px;
  border-radius: $radius-lg;
  background: var(--surface-inverse);
  box-shadow: var(--shadow-overlay);
}

.tooltipValue {
  font-size: $font-size-13;
  font-weight: $font-weight-medium;
  line-height: 1.2;
  color: var(--text-inverse);
}

.tooltipDate {
  font-size: $font-size-11;
  line-height: 1.2;
  color: rgba(255, 255, 255, 0.7);
}
